document.addEventListener('DOMContentLoaded', () => {
  /**
   * Logic to auto-open cart based on query parameter
   */
  const urlParams = new URLSearchParams(window.location.search)
  const withCartOpen = urlParams.get('with-cart-open')
  if (withCartOpen) {
    Promise.all([
      customElements.whenDefined('dna-mini-cart'),
      customElements.whenDefined('sl-drawer'),
    ]).then(() => {
      document.dispatchEvent(new CustomEvent('dna:cart:open'))
      window.history.replaceState({}, document.title, window.location.pathname)
    })
  }

  /* ========== Drawer Event Handlers ========== */
  /**
   * Global event handler to open a specific drawer by its ID.
   * @param {string} id - The ID of the drawer to open.
   */
  function openDrawerById(id) {
    const $drawer = document.querySelector(`sl-drawer#${id}`)
    if ($drawer) {
      $drawer.show()
    }
  }

  /**
   * Custom event listener for opening a drawer.
   */
  document.addEventListener('dna:drawer:open', ({ detail: { id } }) =>
    openDrawerById(id),
  )

  /**
   * Automatically apply close handlers to all drawers.
   * Finds all 'sl-drawer' elements and attaches a click event listener
   * to their respective '.js-close' elements.
   */
  const $drawers = document.querySelectorAll('sl-drawer')
  for (const $drawer of $drawers) {
    const $close = $drawer.querySelector('.js-close')
    if ($close) {
      $close.addEventListener('click', () => $drawer.hide())
    }
  }

  /**
   * Event listener for the 'sl-after-show' event.
   * Triggered when a drawer is shown.
   */
  document.addEventListener('sl-after-show', () =>
    document.dispatchEvent(new CustomEvent('dna:header:hide')),
  )

  /**
   * Event listener for the 'sl-after-hide' event.
   * Triggered when a drawer is hidden.
   */
  document.addEventListener('sl-after-hide', () =>
    document.dispatchEvent(new CustomEvent('dna:header:show')),
  )

  /* ========== End of Drawer Event Handlers ========== */
})
